
import React, { useEffect, useRef } from 'react';
import { Flag } from 'lucide-react';

const GenerateRedFlagImage = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  
  useEffect(() => {
    const renderFlagImage = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      
      // Clear canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Set white background
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Create an SVG element to render the Flag component
      const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 24 24">
          <g fill="none" stroke="#FF3B30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
            <line x1="4" y1="22" x2="4" y2="15"></line>
          </g>
        </svg>
      `;
      
      // Create a temporary image to draw the SVG
      const img = new Image();
      const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
      const svgUrl = URL.createObjectURL(svgBlob);
      
      img.onload = () => {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(svgUrl);
        
        // Generate download link
        const downloadLink = document.getElementById('download-flag') as HTMLAnchorElement;
        if (downloadLink) {
          downloadLink.href = canvas.toDataURL('image/jpeg', 0.9);
          downloadLink.download = 'redflags-icon-300x300.jpg';
          downloadLink.style.display = 'inline-block';
        }
      };
      
      img.src = svgUrl;
    };
    
    renderFlagImage();
  }, []);
  
  return (
    <div className="flex flex-col items-center gap-4 p-6 border rounded-md">
      <h3 className="text-xl font-bold">RedFlags Logo - Flag Icon</h3>
      <canvas 
        ref={canvasRef} 
        width={300} 
        height={300} 
        className="border rounded-md shadow-sm"
      />
      <div className="flex gap-2">
        <a 
          id="download-flag" 
          href="#" 
          className="bg-redflags-red text-white px-4 py-2 rounded-md hover:bg-redflags-red/90 inline-flex items-center"
          style={{ display: 'none' }}
        >
          Download JPG (300x300)
        </a>
      </div>
      <div className="text-sm text-redflags-gray mt-2">
        This is the exact flag icon from your Lucide React component, exported as a JPG image.
      </div>
    </div>
  );
};

export default GenerateRedFlagImage;
